import React from 'react';
import { Close } from '@mui/icons-material';

import { useSelector, useDispatch } from 'react-redux';
import { HTMLContent } from '../Content';
import { topAlertMessage } from '../../utils/displayOptions';

export default function TopAlert() {
  const siteConfig = useSelector((state) => state.siteConfig);
  const dispatch = useDispatch();

  if (!siteConfig.showTopAlert || !topAlertMessage || topAlertMessage === '') {
    return null;
  }

  return (
    <div className='relative border-b border-neutral-content bg-neutral px-4 py-12 py-4 text-center text-lg font-bold text-neutral-content md:px-20 [&_a]:text-neutral-content [&_a]:hover:text-primary'>
      <HTMLContent content={topAlertMessage} />
      <button
        type='button'
        className='absolute right-0 top-0 cursor-pointer bg-none p-3.5 text-neutral-content'
        aria-label='close'
        onClick={() => dispatch({ type: 'SITECONFIG_HIDE_TOP_ALERT' })}
      >
        <Close />
      </button>
    </div>
  );
}
